import React from 'react';
import {Section, Table, NameCell, ValueCell, InputCell, RemoveCell, AddRowButton} from '../components/cells';
import {money, money2, count, percent} from '../model/format';

const HEADER = [
    'Floor Plan', 'Units', 'Avg SF', 'Rent/Mo', 'Rent/ SF', 'Proforma Rent/Mo', 'Proforma Rent/SF',
    'Occupied Units', 'Total SF', 'Monthly Rent', 'Monthly Proforma Rent', 'Annual Rent', null,
];

/**
 * Current Rent Roll sheet: the unit mix. Floor plans can be added and removed; the Total row
 * (B8) is the only unit count used anywhere in the underwriting.
 */
export default function CurrentRentRoll({inputs, calc, setRow, addRow, removeRow}) {
    const roll = calc.rentRoll;
    const total = roll.total;
    const cell = (index, key, props = {}) => (
        <InputCell value={inputs.unit_mix[index][key]} onChange={value => setRow('unit_mix', index, key, value)} {...props}/>
    );

    return (
        <div className='mf-tab mf-rent-roll'>
            <Section
                title='Current Rent Roll'
                description='Unit Mix & In-Place Rents vs. Proforma Rents'
                actions={<AddRowButton label='Add Floor Plan' onClick={() => addRow('unit_mix')}/>}
            >
                <Table className='mf-grid-table mf-rent-roll-table' header={HEADER}
                    footer={
                        <tr className='mf-total-row'>
                            <NameCell>{total.floor_plan}</NameCell>
                            <ValueCell>{count(total.units)}</ValueCell>
                            <ValueCell>{count(total.avg_sf)}</ValueCell>
                            <ValueCell>{money(total.rent)}</ValueCell>
                            <ValueCell>{money2(total.rent_sf)}</ValueCell>
                            <ValueCell>{money(total.proforma_rent)}</ValueCell>
                            <ValueCell>{money2(total.proforma_rent_sf)}</ValueCell>
                            <ValueCell>{count(total.occupied_units)}</ValueCell>
                            <ValueCell>{count(total.total_sf)}</ValueCell>
                            <ValueCell>{money(total.monthly_rent)}</ValueCell>
                            <ValueCell>{money(total.monthly_proforma_rent)}</ValueCell>
                            <ValueCell>{money(total.annual_rent)}</ValueCell>
                            <td className='mf-remove-cell'/>
                        </tr>
                    }
                >
                    {roll.rows.map((row, index) => (
                        <tr key={index}>
                            {cell(index, 'floor_plan', {kind: 'text', className: 'mf-label-input', placeholder: 'Floor plan'})}
                            {cell(index, 'units')}
                            {cell(index, 'avg_sf', {unit: 'SF'})}
                            {cell(index, 'rent', {unit: '$'})}
                            <ValueCell>{money2(row.rent_sf)}</ValueCell>
                            {cell(index, 'proforma_rent', {unit: '$'})}
                            <ValueCell>{money2(row.proforma_rent_sf)}</ValueCell>
                            {cell(index, 'occupied_units')}
                            <ValueCell>{count(row.total_sf)}</ValueCell>
                            <ValueCell>{money(row.monthly_rent)}</ValueCell>
                            <ValueCell>{money(row.monthly_proforma_rent)}</ValueCell>
                            <ValueCell>{money(row.annual_rent)}</ValueCell>
                            <RemoveCell onRemove={() => removeRow('unit_mix', index)} disabled={roll.rows.length <= 1}/>
                        </tr>
                    ))}
                </Table>
                <Table className='mf-kv-table mf-occupancy-table'>
                    <tr><NameCell>Occupancy</NameCell><ValueCell>{percent(roll.occupancy, 0)}</ValueCell></tr>
                </Table>
            </Section>
        </div>
    );
}
